import React, { useContext } from "react";
import { FloatingPortal } from "@floating-ui/react";
import { useModalContext } from "../components/modal/Modal";
import { MainContainerContext, useMainContentContext } from "../components/main-container/MainContainerContext";
import { useFloatingContainerContext } from "../components/floating-container/FloatingContainer";
import { GlobalStyle } from "../theme/GlobalStyle";
const FloatingPortalContainer = ({ container, content, disablePortal = false }) => {
    const modalContext = useModalContext();
    const modalContentRef = modalContext === null || modalContext === void 0 ? void 0 : modalContext.contentRef;
    const mainContainerContext = useContext(MainContainerContext);
    const mainContentContext = useMainContentContext();
    const contentRef = mainContentContext ? mainContainerContext === null || mainContainerContext === void 0 ? void 0 : mainContainerContext.mainContainerRef : undefined;
    const popperContext = useFloatingContainerContext();
    const popperRef = popperContext === null || popperContext === void 0 ? void 0 : popperContext.ref;
    return disablePortal ? (content) : (React.createElement(FloatingPortal, { root: container || popperRef || modalContentRef || contentRef || document.body },
        React.createElement(GlobalStyle, { "data-a11y-ignore": "region" }, content || React.createElement(React.Fragment, null))));
};
export default FloatingPortalContainer;
//# sourceMappingURL=FloatingPortalContainer.js.map